import { e as c } from "./base-D76d76ww.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function m(t, l) {
  return (o, n, s) => {
    const u = (i) => {
      var r, e;
      return (e = (r = i.renderRoot) == null ? void 0 : r.querySelector(t)) != null ? e : null;
    };
    return c(o, n, { get() {
      return u(this);
    } });
  };
}
export {
  m as e
};
